import apiHandler from '../core/apiHandler';

const realtimeApi = apiHandler('realtime');

export default realtimeApi;